// 最後の設問の送信ボタン文言と、送信成功後の遷移先。
// 完了画面は登録導線の次ステップ（プランナー紹介）を案内する画面なので、
// ホーム起点では挟まず結果画面へ直行する。
// 文言と遷移先はセットで切り替える（片方だけ変えると案内と実際の遷移がずれる）。
interface SubmitStep {
  label: string;
  path: string;
}

// 結果は「あなたの投資スタイル」と呼ぶ（診断という手続きの名前は「投資スタイル診断」のまま）
export const HOME_SUBMIT_STEP: SubmitStep = {
  label: "あなたの投資スタイルを見る",
  path: "/investment_style_diagnosis/result",
};

// 登録導線は完了画面を挟むため、ボタンは診断の実行を表す「診断する」（Figma S-14）
export const REGISTRATION_SUBMIT_STEP: SubmitStep = {
  label: "診断する",
  path: "/investment_style_diagnosis/completion",
};

export const buildSubmitStep = (fromHome: boolean): SubmitStep => (fromHome ? HOME_SUBMIT_STEP : REGISTRATION_SUBMIT_STEP);
